import React, { useState } from "react";

import { DialogContentText } from "@material-ui/core";

import {
  Button,
  Confirm,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";

import { RollbackIcon } from "../../../components/common/iconography";
import { logError, logHistory } from "../../../utils/appUtils";
import { InvoiceStatus, ResourceType } from "../../../utils/constants";
import { planReopen } from "./invoicePaymentUtils";
import { CONFLICT_MESSAGE, saveInvoiceChange } from "./saveInvoiceChange";

export const ReopenButton = ({ record }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const handleDialogOpen = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setOpen(true);
  };
  const handleDialogClose = () => setOpen(false);

  const saveInvoice = async () => {
    try {
      setLoading(true);
      debugger;
      if (record) {
        // Works on the invoice as read now: recorded payments still count
        // after a reopen, and the record behind a list row or a page left open
        // may not have them.
        const result = await saveInvoiceChange(record.id, planReopen);
        if (result.skip) {
          notify(
            result.skip === "conflict"
              ? CONFLICT_MESSAGE
              : "Invoice was already reopened.",
            "warning",
          );
          setOpen(false);
          refresh();
          return;
        }

        const historyNote = {
          text: "Invoice reopened.",
          parentId: record.id,
          parentType: ResourceType.INVOICE,
        };
        logHistory(historyNote);
      }

      notify("Invoice reopened successfully.", "info");
      redirect(`/invoices/${record.id}`);
      refresh();
    } catch (error) {
      logError("invoices:ReopenButton:saveInvoice", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const renderDialogContent = () => {
    return record.status === InvoiceStatus.PAID ? (
      <DialogContentText>
        Ropening will roll back the invoice to "DRAFT" status and mark it as not
        paid/completed.
        <br></br>
        Are you sure you want to reopen this invoice?
      </DialogContentText>
    ) : (
      <DialogContentText>
        Are you sure you want to reopen this invoice?
      </DialogContentText>
    );
  };

  if (record.status === InvoiceStatus.NEW) return null;
  return (
    <>
      <Button
        label="Reopen"
        color="primary"
        onClick={handleDialogOpen}
        disabled={loading}
        loading={loading}
      >
        <RollbackIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title="Reopen Confirmation"
        onConfirm={saveInvoice}
        content={renderDialogContent()}
        onClose={handleDialogClose}
      />
    </>
  );
};
